import { Moment } from "moment";

export const formattedDate = (date: Moment | null): string | null =>
  date ? date.format("YYYY-MM-DD") : null;
